type Props = {
  ticks?: Array<number>;
  scale?: (value: number) => number;
};

export const getHorizontalCoordinates = ({ ticks, scale }: Props) => {
  if (!ticks || !scale) return [];

  return ticks
    .map(tick => {
      if (tick === 0) {
        return null;
      }

      const coordinate = scale(tick);

      return coordinate != null && coordinate ? coordinate : null;
    })
    .filter((coordinate): coordinate is number => coordinate !== null);
};
